module.exports = __webpack_public_path__ + "img/title2.6f59b4d1.png";